import { Droplet } from "lucide-react";

export const Brand = ({ size = "md" }) => {
  const big = size === "lg";
  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <div className="relative grid place-items-center">
        <div className="absolute inset-0 rounded-full blur-md bg-primary/40" />
        <Droplet
          className={`relative text-primary ${big ? "h-9 w-9" : "h-6 w-6"}`}
          strokeWidth={1.6}
          fill="hsl(210 100% 56% / 0.25)"
        />
      </div>
      <span className={`display font-bold tracking-tight ${big ? "text-3xl" : "text-xl"}`}>
        Liquid<span className="text-primary">RP</span>
      </span>
    </div>
  );
};
